import React, {PureComponent} from 'react';
import {Container, Message} from 'semantic-ui-react';

export default class ItemNotFoundComponent extends PureComponent {
    render() {
        return (
            <Container>
                <Message negative
                    icon='warning circle'
                    header="That item doesn't exist"
                    content="Check to make sure that you entered in the correct ItemKey"
                />
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/ItemNotFoundComponent.jsx